import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TenantConfigService } from 'app/config/services/tenant-config.service';
import { EngageFeatureGuard } from 'app/services/engage-feature.guard';
import { PostingModule } from '../posting/posting.module';
import { AlumniSwipperComponent } from './alumni-swiper/alumni-swipper.component';
import { AddNewAudienceDialogComponent } from './dialogs/add-new-audience-dialog/add-new-audience-dialog.component';
import { EngageMoveExperienceMembersDialogComponent } from './dialogs/engage-move-experience-members-dialog/engage-move-experience-members-dialog.component';
import { GrowMoveAudienceMembersDialogComponent } from './dialogs/grow-move-audience-members-dialog/grow-move-audience-members-dialog.component';
import { GrowNewSubAudienceDialogComponent } from './dialogs/grow-new-sub-audience-dialog/grow-new-sub-audience-dialog.component';
import { GrowNewAutomaticAudienceDialogComponent } from './dialogs/grow-new-automatic-audience-dialog/grow-new-automatic-audience-dialog.component';
import { AudienceDisplayNamePipe } from './pipes/audience-display-name.pipe';
import { AudienceFullPathPipe } from './pipes/audience-full-path.pipe';
import { GrowStartComponent } from './grow-start/grow-start.component';
import { GrowApiService } from './services/grow.api-service';
import { AudienceRootComponent } from './tabs/audience-tab-root/audience-root/audience-root.component';
import { AudienceUsersListComponent } from './tabs/audience-tab-root/audience-root/audience/audience-users/audience-users-list/audience-users-list.component';
import { AudienceUsersComponent } from './tabs/audience-tab-root/audience-root/audience/audience-users/audience-users.component';
import { AutomaticAudienceMembersListComponent } from './tabs/audience-tab-root/audience-root/audience/audience-users/automatic-audience-members-list/automatic-audience-members-list.component';
import { RootAudienceUsersListComponent } from './tabs/audience-tab-root/audience-root/audience/audience-users/root-audience-users-list/root-audience-users-list.component';
import { AudienceWidgetsComponent } from './tabs/audience-tab-root/audience-root/audience/audience-widgets/audience-widgets.component';
import { AudienceStartComponent } from './tabs/audience-tab-root/audience-start/audience-start.component';
import { AudienceTabRootComponent } from './tabs/audience-tab-root/audience-tab-root.component';
import { ExperienceRootComponent } from './tabs/experience-tab-root/experience-root/experience-root.component';
import { ExperienceHomeComponent } from './tabs/experience-tab-root/experience-root/experience/experience-home/experience-home.component';
import { ExperienceUsersListComponent } from './tabs/experience-tab-root/experience-root/experience/experience-users/experience-users-list/experience-users-list.component';
import { ExperienceUsersComponent } from './tabs/experience-tab-root/experience-root/experience/experience-users/experience-users.component';
import { ExperienceComponent } from './tabs/experience-tab-root/experience-root/experience/experience.component';
import { WidgetsComponent } from './tabs/experience-tab-root/experience-root/experience/widgets/widgets.component';
import { ExperienceStartComponent } from './tabs/experience-tab-root/experience-start/experience-start.component';
import { ExperienceTabRootComponent } from './tabs/experience-tab-root/experience-tab-root.component';

import { MatTreeModule } from '@angular/material/tree';
import { MaxBrainSharedModule } from 'app/projects/shared/src/lib/shared.module';
import { MaxBrainModuleModule } from '../module/module.module';
import { MaxBrainMyProfileModulesModule } from '../my-profile-modules/my-profile-modules.module';
import { AddDefaultAudienceDialogComponent } from './dialogs/add-default-audience-dialog/add-default-audience-dialog.component';
import { AddExperienceDialogComponent } from './dialogs/add-experience-dialog/add-experience-dialog.component';
import { GrowFilterByAudienceDialogComponent } from './dialogs/grow-filter-by-audience-dialog/grow-filter-by-audience-dialog.component';
import { GrowFilterByExperienceDialogComponent } from './dialogs/grow-filter-by-experience-dialog/grow-filter-by-experience-dialog.component';
import { PostingDetailsDialogComponent } from './dialogs/posting-details-dialog/posting-details-dialog.component';
import { PostingsCarouselDialogComponent } from './dialogs/postings-carousel-dialog/postings-carousel-dialog.component';
import { RelatedPostDetailsComponent } from './dialogs/related-post-details/related-post-details.component';
import { GrowHomeComponent } from './grow-home/grow-home.component';
import { GrowSearchComponent } from './grow-search/grow-search.component';
import { PostingsSwipperComponent } from './postings-swiper/postings-swipper.component';
import { RelatedPostingsSwipperComponent } from './related-postings-swiper/related-postings-swipper.component';
import { AudienceResolver } from './services/audience.resolver';
import { GrowPreviewApiService } from './services/grow-preview.service';
import { SidenavService } from './services/sidenav.service';
import { GrowGuard } from './services/grow.guard';
import { AudienceMembersActionsService } from './services/audience-members-actions.service';
import { MaxBrainAllUsersModule } from '../all-users/all-users.module';
import { UserDetailsCardModule } from '../shared/user-details-card/user-details-card.module';
import { RelevantExperiencesComponent } from './tabs/audience-tab-root/audience-root/audience/relevant-experiences/relevant-experiences.component';
import { ExperienceCatalogComponent } from './tabs/experience-tab-root/experience-root/experience/experience-catalog/experience-catalog.component';
import { CourseCatalogModule } from '../course-catalog/course-catalog.module';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
    imports: [
        MatToolbarModule,
        MatSidenavModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatTooltipModule,
        MatDialogModule,
        FormsModule,
        MatProgressSpinnerModule,
        MatCheckboxModule,
        MatTableModule,
        MatSortModule,
        MatSlideToggleModule,
        MatPaginatorModule,
        MatSelectModule,
        MatTreeModule,
        RouterModule,
        MaxBrainSharedModule,
        PostingModule,
        MatTabsModule,
        MatChipsModule,
        MaxBrainModuleModule,
        MaxBrainMyProfileModulesModule,
        MaxBrainAllUsersModule,
        UserDetailsCardModule,
        CourseCatalogModule,
        DragDropModule,
    ],
    declarations: [
        ExperienceStartComponent,
        AudienceRootComponent,
        GrowStartComponent,
        ExperienceComponent,
        ExperienceTabRootComponent,
        ExperienceHomeComponent,
        WidgetsComponent,
        AudienceUsersComponent,
        AutomaticAudienceMembersListComponent,
        AudienceUsersListComponent,
        RootAudienceUsersListComponent,
        ExperienceUsersComponent,
        ExperienceUsersListComponent,
        ExperienceRootComponent,
        AudienceTabRootComponent,
        AudienceStartComponent,
        AudienceWidgetsComponent,
        AddNewAudienceDialogComponent,
        GrowNewSubAudienceDialogComponent,
        GrowNewAutomaticAudienceDialogComponent,
        AudienceDisplayNamePipe,
        AudienceFullPathPipe,
        GrowMoveAudienceMembersDialogComponent,
        EngageMoveExperienceMembersDialogComponent,
        GrowHomeComponent,
        AlumniSwipperComponent,
        PostingsSwipperComponent,
        RelatedPostingsSwipperComponent,
        PostingsCarouselDialogComponent,
        PostingDetailsDialogComponent,
        RelatedPostDetailsComponent,
        GrowSearchComponent,
        GrowFilterByExperienceDialogComponent,
        GrowFilterByAudienceDialogComponent,
        AddExperienceDialogComponent,
        AddDefaultAudienceDialogComponent,
        RelevantExperiencesComponent,
        ExperienceCatalogComponent,
    ],
    exports: [
        MatFormFieldModule,
        MatInputModule,
        GrowHomeComponent,
        GrowSearchComponent,
        PostingsCarouselDialogComponent,
        PostingDetailsDialogComponent,
        RelatedPostDetailsComponent,
        RelatedPostingsSwipperComponent,
        GrowFilterByExperienceDialogComponent,
        GrowFilterByAudienceDialogComponent,
        AddExperienceDialogComponent,
        AddDefaultAudienceDialogComponent,
        AudienceDisplayNamePipe,
        AudienceFullPathPipe,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GrowModule {
    static forRoot(): ModuleWithProviders<GrowModule> {
        return {
            ngModule: GrowModule,
            providers: [
                GrowApiService,
                SidenavService,
                TenantConfigService,
                GrowPreviewApiService,
                EngageFeatureGuard,
                AudienceResolver,
                GrowGuard,
                AudienceMembersActionsService,
            ],
        };
    }
}
